import type { PageSize, Rotation, RotationDirection } from "@WebTypes/pdf";

export const ROTATION_NONE: Rotation = 0;

const QUARTER_TURNS: Record<Rotation, Record<RotationDirection, Rotation>> = {
  0: { left: 270, right: 90 },
  90: { left: 0, right: 180 },
  180: { left: 90, right: 270 },
  270: { left: 180, right: 0 },
};

export function nextRotation(current: Rotation, direction: RotationDirection): Rotation {
  return QUARTER_TURNS[current][direction];
}

export function isQuarterTurn(rotation: Rotation): boolean {
  return rotation === 90 || rotation === 270;
}

export function rotatedSize(size: PageSize, rotation: Rotation): PageSize {
  return isQuarterTurn(rotation) ? { width: size.height, height: size.width } : size;
}

export function rotationTransform(rotation: Rotation): string {
  return `rotate(${rotation}deg)`;
}

export function rotationForPage(rotations: Record<number, Rotation>, pageNumber: number): Rotation {
  return rotations[pageNumber] ?? ROTATION_NONE;
}
